import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../../../core/i18n';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../../../models/action/core';
import { IPagedQueryS } from '../../../../../models/components/paginate';
import { IQuestions, IStudents } from '../../../../../models/components/add-exam-sessions';

const T = Translator.create();
const _logger = Log.create('add session modal tabpanel');

interface IAddSessionTabsProps {
    currentTab: string;
    changeTab: (tabName: string) => void;
    questionDatas?: {
        filters: IPagedQueryS;
        results: IQuestions[] | null;
    };
    studentDatas?: {
        filters: IPagedQueryS;
        results: IStudents[] | null;
    };
}

class AddSessionTabs extends Component<IAddSessionTabsProps> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <ul className="nav nav-tabs border-0" id="tabs" role="tablist" style={{position:'relative',zIndex:'999999', paddingInlineStart: "0px"}}>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionProperties' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionProperties')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_properties')} &nbsp; <em>1/7</em>
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionAddQuestion' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionAddQuestion')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_add_page_questions')}  &nbsp; <em>2/7</em>
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionQuestions' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionQuestions')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_questions_page')}({ this.props.questionDatas && this.props.questionDatas.filters && this.props.questionDatas.filters.total ? this.props.questionDatas.filters.total : 0 }) 
                        &nbsp; <em>3/7</em>
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionStudents' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionStudents')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_added_students')}({ this.props.studentDatas && this.props.studentDatas.filters && this.props.studentDatas.filters.total ? this.props.studentDatas.filters.total : 0 }) 
                        &nbsp; <em>4/7</em>
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionAddStudent' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionAddStudent')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_add_page_students')} &nbsp; <em>5/7</em>
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={this.props.currentTab === '_sessionAddSecurity' ? 'nav-link active' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionAddSecurity')}
                        id="security-tab"
                    >
                        {T.t('r_gen_exam_session_security')} &nbsp; <em>6/7</em>
                    </a>
                </li>
                <li className="nav-item session-publish">
                    <a
                        className={this.props.currentTab === '_sessionPublish' ? 'nav-link active session-publish' : 'nav-link '}
                        onClick={this.props.changeTab.bind(this, '_sessionPublish')}
                        id="all-users-tab"
                    >
                        {T.t('r_gen_exam_session_publish')} &nbsp; <em>7/7</em>
                    </a>
                </li>
            </ul>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddSessionTabsProps): IAddSessionTabsProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddSessionTabsProps = Object.assign({}, ownProps, {
        questionDatas: state.examSession.questionDatas,
        studentDatas: state.examSession.studentDatas
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.examSession.questionDatas === prev.examSession.questionDatas &&
        next.examSession.studentDatas === prev.examSession.studentDatas
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddSessionTabs = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddSessionTabs);

export default CAddSessionTabs;
